<template>
  <v-card class="my-1" outlined>
    <v-row justify="space-around" class="ma-0" align="center">

      <v-col cols="auto" class="d-flex flex-column pa-2 py-2" style="min-width: 10rem;">
        <span class="text-h6 font-weight-black" v-text="pratica.documentNbr"/>
        <v-row dense class="ma-0">
          <v-col class="py-0 text-caption">
            <ReadonlyField :label="$t('label.createDate')" :value="createDate"/>
          </v-col>
          <v-col class="py-0 text-caption">
            <ReadonlyField :label="$t('label.updateDate')" :value="updateDate"/>
          </v-col>
        </v-row>
      </v-col>

      <v-divider vertical/>

      <v-col class="pa-1 d-flex align-center">
        <v-row dense class="ma-0" style="width: 100%;">
          <v-col class="py-0 px-1" style="font-size: 0.85rem;color: rgba(0, 0, 0, 0.7);font-weight:500">
            <ReadonlyField :label="$t('label.shipper')" :value="pratica.shipperName"/>
          </v-col>
          <v-col class="py-0 px-1" style="font-size: 0.85rem;color: rgba(0, 0, 0, 0.7);font-weight:500">
            <ReadonlyField :label="$t('label.consignee')" :value="pratica.consigneeName"/>
          </v-col>
        </v-row>
      </v-col>

      <v-divider vertical/>

      <v-col class="pa-1 d-flex align-center justify-center">
        <div class="d-flex align-center" style="gap: 0.5rem; width: 100%; max-width: 32rem;">

          <div class="d-flex flex-column align-center" style="min-width: 7rem; max-width: 9rem;">
            <v-avatar size="36" style="border: 2px solid var(--v-primary-base)">
              <v-icon size="18" color="primary">mdi-ferry</v-icon>
            </v-avatar>
            <span
                class="location-label"
                :title="pratica.polLabel">
              {{ pratica.polLabel }}
            </span>
          </div>

          <div class="d-flex flex-column align-center flex-grow-1" style="min-width: 0;">
            <div class="d-flex align-center" style="width: 100%;">
              <v-divider/>
              <v-icon size="12" color="primary" style="flex-shrink: 0;">mdi-navigation-variant</v-icon>
              <v-divider/>
            </div>
            <v-chip
                v-if="pratica.vesselName"
                small
                class="vessel-name"
                color="blue-grey lighten-5"
                :title="pratica.vesselName">
              {{ pratica.vesselName }}
            </v-chip>
          </div>

          <div class="d-flex flex-column align-center" style="min-width: 7rem; max-width: 9rem;">
            <v-avatar size="36" style="border: 2px solid var(--v-primary-base)">
              <v-icon size="18" color="primary">mdi-ferry</v-icon>
            </v-avatar>
            <span
                class="location-label"
                :title="pratica.podLabel">
              {{ pratica.podLabel }}
            </span>
          </div>

        </div>
      </v-col>

      <v-divider vertical/>

      <v-col cols="auto" class="pa-2 d-flex flex-column align-center justify-center"
             style="gap: 0.5rem; min-width: 3rem;">
        <v-btn icon small @click="expandTracking = !expandTracking" color="grey darken-1">
          <v-icon small>{{ expandTracking ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
        <v-btn v-if="pratica.masterVisible" icon small @click="goToPratica" color="primary">
          <v-icon small>mdi-eye-outline</v-icon>
        </v-btn>
      </v-col>

    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="pa-0">
        <HouseBLExtension :open="expandTracking" :houses="houses" v-if="houseVisibilityAuth"/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {mapState} from 'vuex'
import {dateFilter} from '@/filters/dateFilter'
import ReadonlyField from '@/components/elements/ReadonlyField.vue'
import HouseBLExtension from "../houseBL/HouseBLExtension";


export default {
  name: 'ETPraticaRow',
  props: ['pratica', 'houses', 'currentSelection', 'showSelection'],
  emits: ['select-row', 'add-to-selection'],
  components: {ReadonlyField, HouseBLExtension}, // Details
  data() {
    return {
      expandTracking: false,
    }
  },
  watch: {
    pratica: {
      handler() {
        this.expandTracking = false
      },
      deep: true,
    },
  },
  computed: {
    ...mapState('account', ['isAdmin', 'internalVisibilityAuth', 'houseVisibilityAuth']),
    createDate() {
      return dateFilter.formatDateDayShort(this.pratica.creationDate)
    },
    updateDate() {
      return dateFilter.formatDateDayShort(this.pratica.updateDate)
    },
    selected() {
      return this.currentSelection.includes(this.pratica)
    },
  },
  methods: {
    goToPratica() {
      this.$emit('select-row')
      this.$router.push({
        name: 'pratica',
        params: {id: this.pratica.id},
      })
    },
    addRowToSelection() {
      this.$emit('add-to-selection')
    },
  },
}
</script>

<style scoped>
.checkbox::v-deep .v-input--selection-controls__input {
  margin: 0.3rem !important;
}

.checkbox::v-deep .v-input--selection-controls__ripple {
  height: 0 !important;
}

.location-label {
  width: 10rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
}

.vessel-name {
  max-width: 12rem;
  font-size: 0.7rem;
  text-align: center;
  white-space: normal;
  word-break: break-word;
  display: block;
  color: var(--v-primary-base);
  font-weight: 500;
}

</style>

